<template>
  <div>
    <px-view-header title="Respoder solicitação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1"
               icon
               x-large
               color="primary"
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:after>
        <px-ajuda-icon :link="ajuda"/>
      </template>
    </px-view-header>

    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && solicitacao">
      <px-cotacao-frete-detalhes-card :cotacao="solicitacao.cotacaoFrete"/>
      <px-resposta-cotacao-basico class="mt-3"
                                  :solicitacao="solicitacao"
                                  :edit-resposta="resposta"
                                  :editing="editing"
                                  @ready="onReady"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoSolicitacaoFrete } from 'px-business-components';
import { respostaCotacao } from '@/api/ajuda-mapper';
import CotacaoService from '@/modules/cotacoes/cotacoes-service';
import RespostaCotacaoBasico from './RespostaCotacaoBasico.vue';
import CotacaoFreteDetalhesCard from '../cotacao-card/CotacaoFreteDetalhesCard.vue';

export default {
  data() {
    return {
      id: this.$route.params.id,
      ajuda: respostaCotacao,
      origin: this.$route.query.origin,
      isPainel: false,
      loading: false,
      editing: false,
      solicitacao: null,
      resposta: null,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  computed: {
    ...mapGetters(['empresa', 'isPremium']),
  },
  methods: {

    onReady(solicitacao) {
      let query = {};
      let params = {
        id: this.id,
      };
      if (this.isPainel) {
        query = {
          back: 'PAINEL',
        };
        params = {
          id: solicitacao.id,
        };
      }
      this.$router.push({
        name: 'main.cotacoes.detalhes',
        params,
        query,
      });
    },
    onClickBack() {
      if (this.isPainel) {
        this.$router.push({
          name: 'main.cotacoes.detalhes',
          params: { id: this.id },
          query: { origin: 'PAINEL' },
        });
        return;
      }
      this.$router.push({
        name: 'main.cotacoes.detalhes',
        params: { id: this.id },
      });
    },
    setupEdit() {
      if (this.solicitacao.respostaFrete) {
        this.editing = true;
      }
    },
    getSolicitacao() {
      this.loading = true;
      CotacaoService.getSolicitacao(this.id)
        // eslint-disable-next-line consistent-return
        .then(({ data }) => {
          this.solicitacao = data;
          if (this.solicitacao.respostaFrete) {
            this.editing = true;
            return this.getResposta(this.solicitacao.respostaFrete.id);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCotacao() {
      this.loading = true;
      CotacaoService.getCotacao(this.id)
        .then(({ data }) => {
          this.solicitacao = {
            cotacaoFrete: data,
            situacao: SituacaoSolicitacaoFrete.keys.NAO_RESPONDIDA.key,
            transportadora: this.empresa,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getResposta(idResposta) {
      return CotacaoService.getResposta(idResposta)
        .then(({ data }) => {
          this.resposta = data;
        });
    },
  },
  created() {
    if (this.origin === 'PAINEL') {
      this.isPainel = true;
      if (!this.isPremium) {
        this.onClickBack();
        return;
      }
      this.getCotacao();
      return;
    }
    this.getSolicitacao();
  },
  components: {
    pxRespostaCotacaoBasico: RespostaCotacaoBasico,
    pxCotacaoFreteDetalhesCard: CotacaoFreteDetalhesCard,
  },
};
</script>
